function whenPageReady() {
  return new Promise((resolve) => {
    if (document.readyState === "complete") {
      // When the page is already loaded and user clicks the A2C button
      resolve();
    } else {
      // When the page is not yet loaded and user clicks the A2C button
      window.addEventListener("load", resolve, {once: true});
    }
  });
}

window.addToCartCompleted = false;
window.addToCartPromise = function() {
  return new Promise((resolve) => {
    if (window.addToCartCompleted) {
      resolve();
    }
    else {
      document.addEventListener("cart:main-product-added", resolve, {once: true});
    }
  })
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        var nameId = this.form.querySelector("[name=id]");
        if (nameId) {
          nameId.disabled = false;
        }
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

      }
      
      async onSubmitHandler(evt) {
        evt.preventDefault();
        window.addToCartCompleted = false;

        // Moved to click event listener for instant loading effect
        // this.submitButton.setAttribute("aria-disabled", true);
        // this.submitButton.classList.add("loading");
        // this.querySelector(".loading-overlay__spinner").classList.remove(
        //   "hidden"
        // );

        // Open addon popup
        if($('.popup-addon.pop-up:not(.disabled)').length > 0) {
          $(".popup-addon.pop-up").addClass("is-open");
          $('html').addClass("disable-scroll");
        } 
        // Open gift card popup
        if($('.popup-gift-card.pop-up:not(.disabled)').length > 0) {
          $(".popup-gift-card.pop-up").addClass("is-open");
          $('html').addClass("disable-scroll");
        } 

        // Scroll to addon section
        // This stalls the user until add to cart is done
        let addonSectionScrollOffset;
        if (window.innerWidth > 767) {
          addonSectionScrollOffset = `${$('.header_main')?.innerHeight() + $('.header_main .delivery-countdown-wrapper')?.innerHeight() + 20}px`;
        } else {
          addonSectionScrollOffset = `${$('.header_main')?.innerHeight() + $('.header_main .delivery-countdown-wrapper')?.innerHeight() + $('.product-form__wrap').innerHeight() + 75}px`;
        }

        $('.shopify-section:has(.addons-tab-wrapper)')?.css("scrollMarginBlock", addonSectionScrollOffset);
        console.log($('.shopify-section:has(.addons-tab-wrapper)')?.css("scrollMarginBlock"));
        
        $('.shopify-section:has(.addons-tab-wrapper)')[0].scrollIntoView({
          behavior: "smooth",
          block: "start"
        })

        var button_sec = $(
          ".addtocart-btn-trigger .button"
        );
        // Changes the addon section's button to Proceed to cart button
        // button_sec.addClass("sec-cart-btn disabled").prop("disabled", true);
        button_sec.addClass("sec-cart-btn").removeClass('disabled').prop("disabled", false);

        // var svgElement = button_sec.querySelector("svg");
        // if (svgElement) {
        //   button_sec.removeChild(svgElement);
        // }
        button_sec.find("span.button__title"
        ).text("Proceed to Cart");
        button_sec.find(".loading-overlay__spinner")?.addClass("hidden");
        
        // if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        // FOR ONLY VDAY PRODUCTS
        // Attach event listener for popupclose before cart:added triggers
        if ($(".product__info-container .addon-select-popup").length > 0 && $(".product__info-container .button--addon-popup").length > 0) {
          $(document).on("addon-popup:closed", function() {
            // $(document).one("cart:added", function() {
              $('.addon-select-popup')?.removeClass('is-open');
              document.querySelector("cart-drawer.drawer").classList.add("active");
              document.querySelector("html").classList.add("disable-scroll");
            // })
          })
        }

        this.handleErrorMessage();

        await whenPageReady();
        console.log("PAGE READY -> SUBMIT HANDLING");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;


        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                {once: true}
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );

            if ($(".product__info-container .addon-select-popup").length > 0 && $(".product__info-container .button--addon-popup").length > 0) {
              $(".product__info-container .button--addon-popup").prop('disabled', false).find('.loading-overlay__spinner').addClass('hidden');
              $('.product__info-container .addon-select-popup').addClass('is-open');
              $('html').addClass("disable-scroll");
            }

            this.afteraddtocart();
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      afteraddtocart() {
        if($('.popup-addon.pop-up.is-open').length <= 0) {
          document.dispatchEvent(new CustomEvent('cart:refresh-addons'));
        } 

        var button_sec = $(
          ".addtocart-btn-trigger .button"
        );
        button_sec.removeClass("disabled").prop("disabled", false);

        // Flag for Proceed to Cart button to open the minicart
        addToCartCompleted = true;
        document.dispatchEvent(new CustomEvent("cart:main-product-added"));
        
        document.dispatchEvent(new CustomEvent("cart:added"));
        document.querySelector(".product-form__submit").classList.add("added");
        document.querySelector(".product-form__submit span.button__title").innerHTML =
          "Added";

        // FOR ONLY VDAY PRODUCTS
        // if ($(".product__info-container .addon-select-popup").length == 0) {
        //   document.querySelector("cart-drawer.drawer").classList.add("active");
        //   document.querySelector("html").classList.add("disable-scroll");
        // } else {
        //   $('.addon-select-popup .cart-btn')?.prop("disabled", false);
        // }
        // document.querySelector('.top-btn').classList.add('show');
        // document.querySelector('.bottom-btn').classList.add('show');
        var elementPosition = document.querySelector(
          ".addons-tab-wrapper"
        ).offsetTop;

        var addtocart_wrapper = document.querySelector(".product-form__wrap");
        if (!addtocart_wrapper.classList.contains("mday")) {
          var popup_status = sessionStorage.getItem("collection_popup_status");
          var soldout_popup = JSON.parse(
            sessionStorage.getItem("soldout_popup")
          );
          var soldout_status = soldout_popup?.status;
          console.log({soldout_status});
          if (popup_status != "shown" && soldout_status != "shown") {
            $(".hover_bkgr_fricc").show();
            $(".hover_bkgr_fricc").addClass("active-popup");
            sessionStorage.setItem("collection_popup_status", "shown");
          }
        }

        refreshFsLightbox();
        hide_addon_tab();
        initCountdown();

        setTimeout(function () {
          // window.scrollTo({
          //   top: elementPosition - 100,
          //   behavior: "smooth"
          // });
          document
            .querySelector(".product-form__submit")
            .classList.remove("added");
          document.querySelector(".product-form__submit span.button__title").innerHTML =
            "Proceed to Checkout";

          // Changes the addon section's button to Checkout button
          // button_sec.classList.add("sec-checkout-btn");

          // var svgElement = button_sec.querySelector("svg");
          // document.querySelector(
          //   ".addtocart-btn-trigger .button span"
          // ).innerHTML = "Proceed to Checkout";
          // if (svgElement) {
          //   button_sec.removeChild(svgElement);
          // }

          document
            .querySelector(".product-form__submit")
            .classList.add("sec-checkout-btn");
          document.querySelector(
            ".product-form__submit"
          ).dataset.additionalProductsHandled = "true";

          if ($(".product__info-container .addon-select-popup").length > 0 && $(".product__info-container .button--addon-popup").length > 0) {
            $('.product__info-container .product-form__submit')?.show();
            $('.product__info-container .button--addon-popup')?.hide();
          }
        }, 1500);
      }
    }
  );
}

// Mobile Add To Cart Sticky Header
// document.addEventListener("DOMContentLoaded", function () {
//   function addClassWhenTouchingHeader(selector, className, options = {}) {
//     const header = document.querySelector(options.headerSelector || '.header_main');
//     if (!header) return;

//     const targets = Array.from(document.querySelectorAll(selector));
//     if (!targets.length) return;

//     let ticking = false;
//     let headerHeight = header.getBoundingClientRect().height;

//     const onResize = () => {
//       headerHeight = header.getBoundingClientRect().height;
//       check();
//     };
//     window.addEventListener('resize', throttle(onResize, 150));

//     const mo = new MutationObserver(onResize);
//     mo.observe(header, { childList: true, subtree: true, attributes: true });

//     function check() {
//       headerHeight = header.getBoundingClientRect().height;

//       for (const el of targets) {
//         const rect = el.getBoundingClientRect();
//         const nextEl = el.nextElementSibling;

//         const touchedOrAbove = rect.top <= headerHeight;
//         const completelyAbove = rect.bottom <= headerHeight;

//         if (touchedOrAbove && completelyAbove) {
//           nextEl.classList.add(className);
//           nextEl.style.top = headerHeight + 'px';
//         } else if (!touchedOrAbove) {
//           nextEl.classList.remove(className);
//         }
//       }
//       ticking = false;
//     }

//     function onScroll() {
//       if (!ticking) {
//         ticking = true;
//         requestAnimationFrame(check);
//       }
//     }
//     window.addEventListener('scroll', onScroll, { passive: true });
//     requestAnimationFrame(check);

//     return function destroy() {
//       window.removeEventListener('scroll', onScroll);
//       window.removeEventListener('resize', onResize);
//       mo.disconnect();
//     };
//   }

//   function throttle(fn, wait = 100) {
//     let last = 0;
//     return function (...args) {
//       const now = Date.now();
//       if (now - last >= wait) {
//         last = now;
//         fn.apply(this, args);
//       }
//     };
//   }

//   addClassWhenTouchingHeader('.mobile-sticky-addtocart-btn', 'sticky-addtocart-mobile', {
//     headerSelector: '.header_main'
//   });
// });

// function whenPageReady() {
//   return new Promise((resolve) => {
//     if (document.readyState === "complete") {
//       // When the page is already loaded and user clicks the A2C button
//       resolve();
//     } else {
//       // When the page is not yet loaded and user clicks the A2C button
//       window.addEventListener("load", resolve, {once: true});
//     }
//   });
// }

// async function test() {
//   console.time("Page ready time");
//   await whenPageReady();
//   console.timeEnd("Page ready time");
//   console.log("Page is ready");
// }
// test();

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header_main");
  const trigger = document.querySelector(".product__info-container .product-form__wrap");
  if (!header || !trigger) return;

  const target = trigger.previousElementSibling || document.querySelector(".product__info-container .mobile-sticky-addtocart-btn");
  if (!target) return;

  let ticking = false;
  let isSticky = false;

  function getHeaderHeight() {
    return header.offsetHeight - 1;
  }

  let initialHeaderHeight = getHeaderHeight();
  function updateSticky() {
    const headerHeight = getHeaderHeight();
    const rect = trigger.getBoundingClientRect();

    // Trigger has crossed the top of the viewport
    if (rect.top <= 0) {
      if (!isSticky) {
        isSticky = true;
        target.classList.add("sticky-addtocart-mobile");
        target.style.top = headerHeight + "px";
      } else if (isSticky && initialHeaderHeight != headerHeight) {
        target.style.top = headerHeight + "px";
        initialHeaderHeight = headerHeight;
      }
    } else {
      if (isSticky) {
        isSticky = false;
        target.classList.remove("sticky-addtocart-mobile");
        target.style.top = "";
      }
    }
  }

  if (window.innerWidth <= 1024) {
    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
          ticking = false;
          updateSticky();
        });
      },
      {passive: true}
    );
  }

  window.addEventListener("resize", updateSticky);

  // Run once on load
  updateSticky();
});